import React, { useState } from 'react';

interface Props {
  onLogin: () => void;
}

const Login: React.FC<Props> = ({ onLogin }) => {
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = () => {
    if (login === 'ADC' && password === '141197') {
      localStorage.setItem('auth', 'true');
      localStorage.setItem('authTime', Date.now().toString());
      onLogin();
    } else {
      setError('Неверный логин или пароль');
    }
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-content">
        <img src="/logo.png" alt="Логотип" className="passlogo" />
        <h2 style={{ marginBottom: '16px', textAlign: 'center' }}>Вход в систему</h2>
        <h4 style={{ marginBottom: '16px', textAlign: 'center' }}>Мониторинг валидации пропусков</h4>
        <h4 style={{ marginBottom: '16px', textAlign: 'center' }}>на аэродром «Красноярск»</h4>
        <br />
        <br /> 

        {error && <div className="form-error-above">{error}</div>}

        <input
          type="text"
          placeholder="Логин"
          value={login}
          onChange={(e) => setLogin(e.target.value)}
        />
        <input
          type="password"
          placeholder="Пароль"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '16px' }}>
          <button onClick={handleSubmit} style={{ width: '100%' }}>Войти</button>
        </div>
        <br />
         <h5 style={{ marginBottom: '16px', textAlign: 'center' }}>JM © Е.Н. Мельничук, 2025</h5>
      </div>
    </div>
  );
};

export default Login;
